<button mat-raised-button color="accent" class="me-2 mb-2" *ngIf="!(isFollowing$ | async) || !(isLoggedIn$ | async)" (click)="follow()">
    {{'follow' | translate}}
</button>

<button mat-raised-button color="accent" class="me-2 mb-2" *ngIf="isFollowing$ | async" (click)="unfollow()">
    {{'unfollow' | translate}}
</button>
